
<template>
  <div class="system-useragreement">
    <div class="top-title">用户协议</div>
    <!-- <Card dis-hover> -->
    <div class="lists clearfix list-margin">
      <div class="common-list table-margin">
        <Table
          class="useragreementTable"
          :columns="dataColumn"
          :data="dataLists"
        ></Table>
      </div>
      <div class="common-page fr">
        <Page
          show-total
          show-elevator
          show-sizer
          :total="pageInfo.total"
          :current="pageInfo.page"
          :page-size="pageInfo.limit"
          @on-change="getLists"
        ></Page>
      </div>
    </div>
    <!-- </Card> -->
    <UseragreementDrawer
      ref="useragreementDrawer"
      :showlistDrawer="showlistDrawer"
      :closeDrawer="closeDrawer"
      :getLists="getLists"
      :curItemDetail="curItemDetail"
    ></UseragreementDrawer>
    <div v-if="showModal">
      <UseragreementModal
        ref="useragreementModal"
        :curItemDetails="curItemDetails"
        @on-close-cancel="onCloseCancel"
      ></UseragreementModal>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import ls from "store2";
import deepcopy from "deepcopy";
import UseragreementDrawer from "./components/useragreement-drawer";
import UseragreementModal from "./components/useragreement-modal.vue";
export default {
  components: { UseragreementDrawer, UseragreementModal },
  data() {
    return {
      datas: [],
      dataForm: {
        content: "",
        remarks: "",
        id: "",
        title: "",
        status: "",
      },
      pageInfo: {
        limit: 10,
        page: 1,
        total: 0,
      },
      showModal: false,
      curItemDetail: {},
      curItemDetails: {},
      showlistDrawer: false,
      dataLists: [],
      dataColumn: [
        {
          title: "序号",
          type: "index",
          width: 80,
          //  fixed: 'left',
        },
        {
          title: "用户协议名称",
          key: "title",
          width: 200,
          render: (h, params) => {
            const item = params.row;
            return h("div", item.title || "-");
          },
        },
        {
          title: "协议状态",
          width: 100,
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {
                  style: {
                    marginRight: "8px",
                  },
                },
                params.row.status == "published" ? "已发布" : "已下线"
              ),
            ]);
          },
        },
        {
          title: "创建时间",
          key: "gmtCreate",
          width: 200,
          render: (h, params) => {
            const item = params.row;
            return h("div", item.gmtCreate || "-");
          },
        },
        {
          title: "最新发布时间",
          key: "gmtCreate",
          width: 200,
          render: (h, params) => {
            const item = params.row;
            return h("div", item.gmtModified || "-");
          },
        },
        {
          title: "备注",
          key: "remarks",
          render: (h, params) => {
            const item = params.row;
            return h("div", item.remarks || "-");
          },
        },
        {
          title: "操作",
          key: "address",
          align: "left",
          width: 240,
          className: "action",
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {
                  props: {
                    size: "small",
                  },
                  style: {
                    color: "#0C479DFF",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.preview(params.row);
                    },
                  },
                },
                "查看"
              ),
              h(
                "span",
                {
                  style: {
                    color: "#ddd",
                    margin: "0 10px",
                    verticalAlign: "middle",
                  },
                },
                "|"
              ),
              h(
                "span",
                {
                  props: {
                    size: "small",
                  },
                  style: {
                    color: "#0C479DFF",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.edit(params.row);
                    },
                  },
                },
                "编辑"
              ),
              h(
                "span",
                {
                  style: {
                    color: "#ddd",
                    margin: "0 10px",
                    verticalAlign: "middle",
                    display:
                      params.row.status == "published"
                        ? "inline-block"
                        : "none",
                  },
                },
                "|"
              ),
              h(
                "span",
                {
                  props: {
                    size: "small",
                  },
                  style: {
                    color: "#0C479DFF",
                    cursor: "pointer",
                    display:
                      params.row.status == "published"
                        ? "inline-block"
                        : "none",
                  },
                  on: {
                    click: () => {
                      this.offline(params.row);
                    },
                  },
                },
                "下线"
              ),
              h(
                "span",
                {
                  style: {
                    color: "#ddd",
                    margin: "0 10px",
                    verticalAlign: "middle",
                    display:
                      params.row.status != "published"
                        ? "inline-block"
                        : "none",
                  },
                },
                "|"
              ),
              h(
                "span",
                {
                  props: {
                    size: "small",
                  },
                  style: {
                    color: "#0C479DFF",
                    cursor: "pointer",
                    display:
                      params.row.status != "published"
                        ? "inline-block"
                        : "none",
                  },
                  on: {
                    click: () => {
                      this.publish(params.row);
                    },
                  },
                },
                "发布"
              ),
            ]);
          },
        },
      ],
    };
  },
  mounted() {
    this.getLists();
  },
  methods: {
    getLists(page) {
      this.$store.state.spinShow = true;
      if (page) this.pageInfo.page = page;
      api
        .axss("post", "/ocm-admin/userAgreement/listPage", {
          ...this.pageInfo,
          ...this.dataForm,
        })
        .then((res) => {
          if (res.code === "00000") {
            const datas = res.data;
            this.dataLists = datas.records;
            this.pageInfo.total = datas.total;
            this.$store.state.spinShow = false;
          }
        });
    },
    publish(value) {
      // 发布
      let obj = {
        content: value.content,
        gmtCreate: value.gmtCreate,
        gmtModified: value.gmtModified,
        id: value.id,
        remarks: value.remarks,
        status: value.status,
        title: value.title,
      };
      api.axss("post", "/ocm-admin/userAgreement/update", obj).then((res) => {
        if (res.code === "00000") {
          this.$Message.success("发布成功");
          this.getLists(); // 刷新列表
        }
      });
    },
    preview(item) {
      this.curItemDetails = deepcopy(item);
      console.log("item", item);

      ls.set("useitem", this.curItemDetails);
      this.$router.push("/system/agreement");
      // this.showModal = true;
      // this.$emit("on-open-modal");
    },
    onCloseCancel(bool) {
      this.showModal = bool;
    },
    edit(item) {
      this.curItemDetail.id = item.id;
      this.getDetails();
    },
    offline(item) {
      
      
      this.curItemDetail = item;
      this.$Modal.confirm({
        title: "您确定要下线该协议吗？",
        content: `协议名称：${this.curItemDetail.title}`,
        onOk: () => {
          this.offlineItem();
        },
        onCancel: () => {},
      });
    },
    offlineItem() {
      api
        .axss("get", `/ocm-admin/userAgreement/del/${this.curItemDetail.id}`)
        .then((res) => {
          if (res.code === "00000") {
            this.$Message.success("下线成功");
            this.curItemDetail = {};
            this.getLists();
          }
        });
    },
    getDetails() {
      api
        .axss(
          "get",
          `/ocm-admin/userAgreement/getDetails/${this.curItemDetail.id}`
        )
        .then((res) => {
          if (res.code === "00000") {
            let curItemDetail = deepcopy(res.data);
        console.log('curItemDetail',curItemDetail)
            // for (let key in curItemDetail) {
            //   let item = curItemDetail[key];
            //   console.log("item", item);
            //   if (typeof item == "string") {
            //     curItemDetail[key] = this.xss.process(item);
            //   }
            // }
            // console.log();
            this.curItemDetail = curItemDetail;
            this.showlistDrawer = true;

            console.log(" this.curItemDetail", this.curItemDetail);
          }
        });
    },
    closeDrawer() {
      this.showlistDrawer = false;
      this.curItemDetail = {};
    },
  },
};
</script>

<style lang='less' scoped>
.system-useragreement {
  .lists {
    margin-top: 20px;
  }
}
</style>